import { type GetWarrantyServicesResponse } from './warranty-services'

export const getWarrantyServicesMock: GetWarrantyServicesResponse = {
  title: 'Included services',
  includedServices: [
    {
      title: '1-year warranty',
      texts: [
        "If your item has a technical defect within the first year, we'll repair or replace it.",
      ],
      type: 'warranty',
    },
    {
      title: '30 days to change your mind',
      texts: [
        'Return your item for any reason within the first 30 days of receiving it. Simple as that!',
      ],
      type: 'return',
    },
    {
      title: 'Free standard shipping',
      texts: [
        'Enjoy free standard shipping on all orders, or splurge on express shipping, from $7.00, if you need your item ASAP.',
      ],
      type: 'shipping',
    },
    {
      title: 'Customer support',
      texts: [
        'You can count on us to always get back to you within 1 business day!',
      ],
      type: 'customerCare',
    },
  ],
  fee: {
    title:
      'Back Market charges a $3.99 Quality Assurance Fee to power the refurb revolution',
    texts: [
      'That means we enable the sellers we partner with to meet the highest quality and service standards and have our team on stand-by if you need extra support.',
    ],
    type: 'fee',
  },
  insuranceBenefits: {
    title: 'Need extra protection?',
    benefits: [
      {
        title: 'Additional protection plan coverage',
        texts: [
          'Coverage for drops, spills, and cracked screens from normal use for portable devices like laptops, smartphones, and tablets.',
        ],
      },
      {
        title: 'Warranty extension',
        texts: [
          'Keep coverage for defects in materials and workmanship for an additional year after the 1-year warranty provided by the seller expires.',
        ],
      },
    ],
  },
}
